import {connect} from 'react-redux';
import * as React from 'react';
import * as selectors from '../selectors';
import ContractlistState, {ListContract} from '../ContractlistState';
import {SortHeader} from './sortHeader';
import {
    ArchiveContract, archiveContract, DeleteContract, deleteContract, FetchContracts, fetchContracts, FirstPage,
    firstPage, GetTotalNumberOfContractsWithFilter, getTotalNumberOfContractsWithFilter, NextPage, nextPage,
    SetSearchString, setSearchString, SetTypeFilter, setTypeFilter, ToggleArchivedFilter, toggleArchivedFilter,
    ToggleShowOtherPeoplesContracts, toggleShowOtherPeoplesContracts
} from '../actions';
import {contractTypes} from '../../../../model/enum-contractTypes';
import {ListContractSortableField, sortableFields} from '../models/SortableFieldEnum';
import {ContractValueCell} from './contractValueCell';
import classNames = require('classnames');
import {ContractRowActions} from './contractRowActions';
import {ContractType, FilterType} from '../../../../integration/representation/contract';


interface ComponentState {
    timer: NodeJS.Timeout;
}

interface TagProps {
}

interface StateProps {
    contracts: ListContract[];
    fetchingContracts: boolean;
    showOtherPeoplesContracts: boolean;
    page: number;
    typeFilter: ContractType | 'all';
    showArchivedContracts: boolean;
    totalNumberOfContractsWithCurrentFilter: number;
    numberOfDisplayedHits: number;
    hasCreatePermission: boolean;
    searchString: string;
    sortByField: string;
    isAscending: boolean;
}

interface DispatchProps {
    doNextPage: NextPage;
    doFirstPage: FirstPage;
    doGetTotalNumberOfContractsWithFilter: GetTotalNumberOfContractsWithFilter;
    doSetSearchString: SetSearchString;
    doToggleShowOtherPeoplesContracts: ToggleShowOtherPeoplesContracts;
    doFetchContracts: FetchContracts;
    doSetTypeFilter: SetTypeFilter;
    doToggleArchivedFilter: ToggleArchivedFilter;
    doArchiveContract: ArchiveContract;
    doDeleteContract: DeleteContract;
}

const mapStateToProps = (state: ContractlistState): StateProps => {
    return {
        contracts: selectors.contracts(state),
        fetchingContracts: selectors.fetchingContracts(state),
        showOtherPeoplesContracts: selectors.showOtherPeoplesContracts(state),
        page: selectors.page(state),
        typeFilter: selectors.typeFilter(state),
        showArchivedContracts: selectors.showArchivedContracts(state),
        totalNumberOfContractsWithCurrentFilter: selectors.totalNumberOfContractsWithCurrentFilter(state),
        numberOfDisplayedHits: selectors.numberOfDisplayedHits(state),
        hasCreatePermission: selectors.hasCreatePermission(state),
        searchString: selectors.stateSearchString(state),
        sortByField: selectors.sortByField(state),
        isAscending: selectors.isAscending(state)
    };
};

const mapDispatchToProps: DispatchProps = ({
    doNextPage: nextPage,
    doFirstPage: firstPage,
    doGetTotalNumberOfContractsWithFilter: getTotalNumberOfContractsWithFilter,
    doSetSearchString: setSearchString,
    doToggleShowOtherPeoplesContracts: toggleShowOtherPeoplesContracts,
    doFetchContracts: fetchContracts,
    doSetTypeFilter: setTypeFilter,
    doToggleArchivedFilter: toggleArchivedFilter,
    doArchiveContract: archiveContract,
    doDeleteContract: deleteContract
});

type Props = TagProps & StateProps & DispatchProps;

class ContractResultsComponent extends React.Component<Props, ComponentState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            timer: null
        };
        this.handleSearchWithDebounce = this.handleSearchWithDebounce.bind(this);
    }

    render() {

        const {
            contracts,
            showOtherPeoplesContracts,
            typeFilter,
            fetchingContracts,
            showArchivedContracts,
            totalNumberOfContractsWithCurrentFilter,
            numberOfDisplayedHits,
            hasCreatePermission,
            searchString
        } = this.props;

        const hasMoreHits = numberOfDisplayedHits < totalNumberOfContractsWithCurrentFilter;

        return (
            <div className={'contract-results'}>
                <label htmlFor={'contract-search'} className={'sr-only'}>Søk i kontrakter</label>
                <label htmlFor={'contract-type-select'} className={'sr-only'}>Velg kontrakttype</label>

                <div className={'contract-results__actions-container flex'}>
                    <div style={{'flexGrow': 2}}>
                        <input id="contract-search" type="text" value={searchString}
                               onChange={this.handleSearchWithDebounce} placeholder={'Søk i kontrakter'}/>
                    </div>
                    <div style={{'flexGrow': 1}}>

                        <select id="contract-type-select" className={''} value={typeFilter}
                                onChange={(e) => this.handleTypeFilter(e)}>
                            <option value="all" key="all">Alle kontrakttyper</option>
                            {contractTypes.map(type => {
                                return (
                                    <option value={type.value} key={type.value}>{type.name}</option>
                                );
                            })}
                        </select>

                        <button onClick={() => this.handleShowOtherPeoplesContracts()} className={classNames({
                            'btn': true,
                            'toggle-button': true,
                            'active': showOtherPeoplesContracts
                        })} aria-pressed={!showOtherPeoplesContracts}>
                            <span className="glyphicon glyphicon-ok"/> Vis andres kontrakter
                        </button>

                        <button onClick={() => this.handleArchivedFilter()}
                                className={classNames({'btn': true, 'toggle-button': true, 'active': showArchivedContracts})}
                                aria-pressed={!showArchivedContracts}>
                            <span className="glyphicon glyphicon-ok"/> Vis arkiverte kontrakter
                        </button>

                    </div>
                    <div style={{'flexGrow': 2}}>
                        {hasCreatePermission && <button className={'btn toggle-button active float-right'}
                                                        onClick={() => this.handleNewContract()}
                        >
                            <span className="glyphicon glyphicon-plus"/>
                            Opprett ny kontrakt
                        </button>
                        }
                    </div>
                </div>

                <div className="contract-results__scroll-container">

                    <table>
                        <thead>
                        <tr className="header">
                            {sortableFields.map(field => {
                                return (
                                    <SortHeader field={field} key={field.name}/>
                                );
                            })}
                        </tr>
                        </thead>

                            <tbody>
                            { fetchingContracts ||
                                contracts.map(contract => {
                                    return (
                                        <tr className={'clickable'} key={contract.id}
                                            onClick={(e) => this.handleOpenContract(e, contract.id)}>

                                            {sortableFields.map(field => {
                                                if (field.name === ListContractSortableField.rowActions) {
                                                    return (
                                                        <td key={field.value + contract.id} onClick={e => e.stopPropagation()}>
                                                            <ContractRowActions contract={contract}/>
                                                        </td>
                                                    );
                                                } else { return (
                                                    <ContractValueCell key={field.value + contract.id} field={field}
                                                                       contract={contract}/>
                                                );
                                                }
                                            })}

                                        </tr>
                                    );
                                })
                            }
                            </tbody>

                    </table>

                    {fetchingContracts ?
                        <div className="text-centered">
                            <div className="cssloader"/>
                        </div>

                        :

                        <div className="contract-results__show-more">
                            <div className="text-centered">
                                <p className="color-mid-gray">
                                    {numberOfDisplayedHits} kontrakter vises<br/>
                                    av totalt {totalNumberOfContractsWithCurrentFilter} treff
                                </p>
                                <button className="show-more__button btn btn-default" disabled={!hasMoreHits}
                                        onClick={() => this.handleNextPage()}> Vis flere kontrakter
                                </button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }

    handleNextPage () {
        this.props.doFetchContracts(this.props.page + 1, this.props.showArchivedContracts, this.props.typeFilter, this.props.searchString, this.props.showOtherPeoplesContracts, false, this.props.sortByField, this.props.isAscending, false);
        this.props.doNextPage();
    }

    handleSearchWithDebounce(event: React.ChangeEvent<HTMLInputElement>) {
        clearTimeout(this.state.timer);
        const searchString = event.target.value;
        this.props.doSetSearchString(searchString);
        this.setState(({timer: setTimeout(() => this.handleSearch(searchString), 500)}));
    }

    handleSearch (searchString: string) {
        const alphaNumericSearchString = this.removeNonAlphaNumericOrWhitespace(searchString);
        this.props.doFirstPage();
        this.props.doGetTotalNumberOfContractsWithFilter(
            this.props.showArchivedContracts,
            this.props.typeFilter as ContractType | 'all',
            alphaNumericSearchString,
            this.props.showOtherPeoplesContracts
        );
        this.props.doFetchContracts(1, this.props.showArchivedContracts, this.props.typeFilter, alphaNumericSearchString, this.props.showOtherPeoplesContracts, true, this.props.sortByField, this.props.isAscending, false);
    }

    removeNonAlphaNumericOrWhitespace(text: string) {
        const nonAlphaNumericOrWhitespace = /[^A-Za-zÆØÅæøå0-9\s]/g;
        return text.replace(nonAlphaNumericOrWhitespace, "");
    }

    handleTypeFilter (event: React.ChangeEvent<HTMLSelectElement>) {
        this.props.doSetTypeFilter(event.target.value);
        this.props.doFirstPage();
        this.props.doGetTotalNumberOfContractsWithFilter(
            this.props.showArchivedContracts,
            event.target.value as ContractType | 'all',
            this.props.searchString,
            this.props.showOtherPeoplesContracts
        );
        this.props.doFetchContracts(1, this.props.showArchivedContracts, event.target.value as ContractType | 'all', this.props.searchString, this.props.showOtherPeoplesContracts, true, this.props.sortByField, this.props.isAscending, false);
    }

    handleOpenContract (event: React.MouseEvent<HTMLTableRowElement>, contractId: string) {
        if (event.ctrlKey || event.metaKey) {
            window.open(`#!/contract/${contractId}`, '_blank');
        } else {
            window.location.hash = '#!/contract/' + contractId;
        }
    }

    handleNewContract () {
        window.location.hash = '#!/newcontract';
    }

    handleShowOtherPeoplesContracts () {
        this.props.doFetchContracts(1, this.props.showArchivedContracts, this.props.typeFilter, this.props.searchString, !this.props.showOtherPeoplesContracts, true, this.props.sortByField, this.props.isAscending, false);
        this.props.doGetTotalNumberOfContractsWithFilter(
            this.props.showArchivedContracts,
            this.props.typeFilter,
            this.props.searchString,
            !this.props.showOtherPeoplesContracts
        );
        this.props.doFirstPage();
        this.props.doToggleShowOtherPeoplesContracts();
    }

    handleArchivedFilter () {
        this.props.doFetchContracts(1, !this.props.showArchivedContracts, this.props.typeFilter, this.props.searchString, this.props.showOtherPeoplesContracts, true, this.props.sortByField, this.props.isAscending, false);
        this.props.doGetTotalNumberOfContractsWithFilter(
            !this.props.showArchivedContracts,
            this.props.typeFilter,
            this.props.searchString,
            this.props.showOtherPeoplesContracts
        );
        this.props.doFirstPage();
        this.props.doToggleArchivedFilter();
    }
}

export const ContractResults = connect(mapStateToProps, mapDispatchToProps)(ContractResultsComponent);
